import { call, put, takeLatest } from "redux-saga/effects";

import { networkErrorHandler } from "../../../utils/errorHandlers";
import {
  forgotPasswordFail,
  forgotPasswordStart,
  forgotPasswordSuccess,
} from "../reducer";
import { httpPostPasswordRecovery } from "../../../services/passwordRecovery";

export function* recoverPassword({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpPostPasswordRecovery, data);

  const { success, raw, message, statusCode } = response;
  if (success) {
    yield put(forgotPasswordSuccess(raw));
    if (callback) {
      callback();
    }
  } else {
    yield put(forgotPasswordFail(message));
    networkErrorHandler(statusCode, message || raw);
  }
}

export default function* onRecoverPasswordStart() {
  yield takeLatest(forgotPasswordStart.type, recoverPassword);
}
